import { useTranslations } from '@npco/utils-translations'
import {
  AnnouncementModal,
  Invoice,
  useIsMobileResolution,
} from '@npco/zeller-design-system'
import { cCOutstandingExpenseComingSoonModalTranslations } from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon/CCOutstandingExpenseComingSoonModal/CCOutstandingExpenseComingSoonModal.i18n'
import { IllustrationWithPill } from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon/CCOutstandingExpenseComingSoonModal/components/InvoiceIllustrationWithPill/InvoiceIllustrationWithPill'
import {
  useCCOutstandingExpenseComingSoonState,
  useGoToCCOutstandingExpenseComingSoon,
} from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon-routing'

import { translationsShared } from 'translations/index'

export const CCOutstandingExpenseComingSoonModalContent = () => {
  const t = useTranslations(cCOutstandingExpenseComingSoonModalTranslations)
  const tShared = useTranslations(translationsShared)
  const { state } = useCCOutstandingExpenseComingSoonState()
  const { goToCCOutstandingExpenseComingSoon } =
    useGoToCCOutstandingExpenseComingSoon()
  const isMobile = useIsMobileResolution()
  const illustrationSize = isMobile ? 'medium' : 'large'

  return (
    <AnnouncementModal
      Illustration={
        <IllustrationWithPill
          illustration={<Invoice size={illustrationSize} />}
        />
      }
      heading={t('modalTitle')}
      description={t('modalBody')}
      primaryButtonLabel={tShared('gotIt')}
      onClickPrimary={() => goToCCOutstandingExpenseComingSoon(undefined)}
      onCancel={() => goToCCOutstandingExpenseComingSoon(undefined)}
      isOpen={state?.stage === 'coming-soon-modal'}
    />
  )
}
